import Vue from 'vue'

export default {
  SET_ACTIVE_TYPE: (state, { type }) => {
    state.activeType = type
  },

  SET_LIST: (state, { type, ids }) => {
    state.lists[type] = ids
  },

  SET_ITEMS: (state, { items }) => {
    items.forEach(item => {
      if (item) {
        Vue.set(state.items, item.id, item)
      }
    })
  },
  DIRECT_TO_CONFIRM_PAGE: (state) => {
    Vue.set(state, 'showResult', true)
  },
  SET_USER: (state, { id, user }) => {
    if (user) {
      if(!user.backgroundImageUrl) {
        user.style = "background: #fffc00"
      } else {
        let background = user.backgroundImageUrl.replace('/original/', '/750x750/')
        background = user.backgroundImageUrl.replace('http://', 'https://')
        user.style = "background-image: url("+background+")"
      }

      if(!user.avatarUrl) {
        user.avatarUrl = "https://lmk.chat/public/avatar.png"
      } else {
        user.avatarUrl = user.avatarUrl.replace('http://', 'https://')
        user.avatarUrl = user.avatarUrl.replace('/original/', '/220x220/')
      }

      if(!user.profileMessage) {
        user.profileMessage = "Send me anonymous messges! LMK anything."
      }

      user.name = user.firstName + " " + (user.lastName || '')
    }
    Vue.set(state.users, id, user || false) /* false means user not found */
  },

  SET_ANSWER_CODE: (state, data) => {
    data.code = 'lmk-1-'+data.code
    state.chat = data
  },
  SET_POLL_ANSWERED: (state, data) => {
    state.answered = true
  },
  SET_PROFILE_MESSAGE_CODE: (state, data) => {
    data.code = 'lmk-2-'+data.code
    state.chat = data
  },
  SET_POLL_GAME: (state, { code, pollGames }) => {
    if(pollGames) {
      Vue.set(state.pollGames, code, pollGames || false)
    }
  },
  SET_QUESTION: (state, { qid, handle, question }) => {
    if(question) {
      question.user.name = question.user.firstName + " " + (question.user.lastName || '')
      question.color = question.color.replace("#", "")
      question.fontColor = '#FFFFFF'
      switch(question.color) {
        case 'FDFF00':
          question.fontColor = '#000000'
          break
        case 'FCFD00':
            question.fontColor = '#000000'
        case '16FFD8':
          question.fontColor = '#000000'
          break
        case 'FFFFFF':
          question.fontColor = '#000000'
          break
        case '21C2FF':
        case '5CF716':
        case 'FF6FC8':
        case 'B100FF':
        case 'FF5464':
        case 'FF7F47':
        case '004FFF':
        case 'FF0093':
        default:
          question.fontColor = '#FFFFFF'
          break
      }
      if (!question.user.avatarUrl) {
        question.user.avatarUrl = "https://lmk.chat/public/avatar.png"
      } else {
        question.user.avatarUrl = question.user.avatarUrl.replace('http://', 'https://')
        question.user.avatarUrl = question.user.avatarUrl.replace('/original/', '/220x220/')
      }
      if (!question.iconImageUrl) {
        question.iconImageUrl = question.user.avatarUrl
      } else {
        question.iconImageUrl = question.iconImageUrl.replace('http://', 'https://')
      }
      if (!question.snapShareStyleId) {
        question.snapShareStyleId = 'n/a'
      }
      if (!question.questionType) {
        question.questionType = 0
      }
    }
    // simulate data
    // question.questionType = 3
    // question.subType = 100
    // question.title = 'weipofnpoqiwrncopiqwnrgpvouibqwepirbvpuiqbepwcnoqiwmepoi[cnpoqwnpuobq3ipurbvpiubqewpivubqpwiubrvpiubpqwiuebv'
    // question.subType = 113
    // question.gameImageUrl = 'https://files.dev.lmk.chat/post-image/original/498be0f7-d03d-44bb-b864-1c97f9fe01d5.jpg'
    // need to remove this later
    Vue.set(state.questions, qid || handle, question || false)
  },
  SET_ROOM: (state, { rid, handle, room }) => {
    if (room) {
      room.avatarUrl = room.inviter.avatarUrl || 'https://www.lmk.chat/public/share_large.png'
    }
    Vue.set(state.rooms, rid || handle, room || false)
  },
  SET_QUIZ: (state, { qid, handle, quiz }) => {
    if (quiz) {
      quiz.avatarUrl = quiz.creator.avatarUrl || 'https://www.lmk.chat/public/share_large.png'
    }
    Vue.set(state.quizzes, qid || handle, quiz || false)
  },
  SET_CONVERSATIONS: (state, { id, conversations }) => {
    if(conversations) {
      Vue.set(state.conversations, id, conversations || false)
    }
  },
  SET_COMMUNITIES: (state, { id, communities }) => {
    if(communities) {
      Vue.set(state.communities, id, communities || false)
    }
  },
  SET_COMMUNITIES_POSTS: (state, { pid, posts }) => {
    if(posts) {
      if (!posts.post.creator.avatarUrl) {
        posts.post.creator.avatarUrl = "/public/avatar.png"
      } else {
        posts.post.creator.avatarUrl = posts.post.creator.avatarUrl.replace('/original/', '/220x220/')
      }
      Vue.set(state.communityPosts, pid, posts || false)
    }
  },
  SET_POST: (state, { pid, post }) => {
    if(post) {
      Vue.set(state.posts, pid, post || false)
    }
  }
}



// WEBPACK FOOTER //
// src/store/mutations.js